import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import { propTypes } from 'react-bootstrap/esm/Image';

const columns = [
    //   { field: 'id', headerName: 'ID', width: 70 },
    { field: 'url', headerName: 'Destination URL', width: 380 },
    { field: 'date', headerName: 'Arrival date', width: 220 },
    { field: 'method', headerName: 'Method', width: 110, type: 'number' }
];

const mnoFilterModel = {
    items: [{ columnField: 'Destination URL', operatorValue: 'contains', value: '' }],
};


export default function DataTable(props) {

    const handleRowClick = (rowParams) => {
        const request = rowParams.row;
        props.setSelectedRequest(request);
    }

    const checkboxSelected = (selectionParams) => {
        props.setCheckedRequests(selectionParams);
    }

    const rows = props.requests;

    return (
        <div className='pb-2'>
            <div style={{ height: 600, width: '100%' }}>
                <DataGrid rows={rows} columns={columns} pageSize={25} onRowClick={handleRowClick} checkboxSelection
                    filterModel={mnoFilterModel}
                    onSelectionChange={checkboxSelected}
                    checkboxSelection={false}
                    showToolbar />
            </div>
        </div>

    );
}
